import {
  Box,
  Text,Tabs, TabList, Tab, TabPanels, TabPanel,Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink 
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectedMenu, setHeaderText } from "../../redux/actions/actions";
import { LoadTutorSubjectExamSchedules } from "../../redux/api_calls/apiCalls";
import ExamScheduleStatistics from "./ExamScheduleStatistics";
import ExamScheduleList from "./ExamScheduleList";
import { useParams} from "react-router-dom";
import { ChevronRightIcon } from '@chakra-ui/icons'
import { useHistory } from "react-router-dom";

export default function ScheduleReports() {
    let { subjectId } = useParams();
    const headerText = useSelector(state => state.headerState.headerText)
    const { TutorSubjectExamSchedules } = useSelector(state => state.TutorSubjectExamSchedules)
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    const [coursesList, setCoursesList] = useState([])
    const [scheduleList, setScheduleList] = useState([])
    let history = useHistory();
    useEffect(() => {
        console.log(subjectId,'subjectId');
        dispatch(setHeaderText('Subject Statistics'))
        dispatch(selectedMenu(8))
        if (!TutorSubjectExamSchedules) {
            dispatch(LoadTutorSubjectExamSchedules(subjectId))
        }
    }, [dispatch,subjectId,scheduleList,TutorSubjectExamSchedules])

    useEffect(() => {
        if (TutorSubjectExamSchedules) {
            setCoursesList(TutorSubjectExamSchedules)
        }
    }, [TutorSubjectExamSchedules])

    useEffect(() => {
        if (TutorSubjectExamSchedules) {
            setScheduleList(TutorSubjectExamSchedules['exam_schedules'])
            console.log(scheduleList,"scheduleList");
        }
    }, [TutorSubjectExamSchedules,scheduleList])

    
    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >
        <Box width={['95%', '95%', '95%', '80%']}  alignItems='right' textAlign='right' mb='2rem' mt='2rem'>
                <Breadcrumb spacing='8px' separator={<ChevronRightIcon color='gray.500' />}>
                      <BreadcrumbItem>
                        <BreadcrumbLink href="#" onClick={history.goBack}>Reports</BreadcrumbLink>
                      </BreadcrumbItem>
                      
                       <BreadcrumbItem isCurrentPage='true'>
                        <BreadcrumbLink href='#' _activeLink={{ color: '#4199e1',fontWeight:'bold',textDecoration:'none' }}>Subject Reports</BreadcrumbLink>
                      </BreadcrumbItem>

                    </Breadcrumb>
            </Box>
            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>{headerText}</Text>
            </Box>
            <Box
                d='flex'
                justifyContent='space-between'
                alignItems='flex-start'
                w='80%'
                mb='3rem'
            >
                <Box
                    w='100%'
                    d='flex'
                    flexDir='column'
                >

            <Tabs width={['100%']}>
                    <TabList style={{ border: 'none' }}>
                        <Tab width="50%"  _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px',fontFamily: 'Mulish, sans-serif' }}>Stats</Tab>
                        <Tab width="50%"  _selected={{ color: 'white', bg: '#4199e1',borderRadius:'10px',fontFamily: 'Mulish, sans-serif' }}>Schedules</Tab>
                    </TabList>

                    <TabPanels>
                        <TabPanel padding="0">
                        <Box
                            d='flex'
                            justifyContent='space-between'
                            alignItems='flex-start'
                            w='100%'
                            mb='3rem'
                        >
                            <Box
                                w='100%'
                                d='flex'
                                flexDir='column'
                            >
                                <Text
                                    fontSize='15px'
                                    color='#222222'
                                    fontWeight='800'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    mb='1rem'
                                >
                                </Text>
                                
                                    <ExamScheduleStatistics statistics={coursesList} />
                                
                            </Box>


                        </Box>
                        </TabPanel>
                        <TabPanel padding="0">
                            <Box
                            d='flex'
                            justifyContent='space-between'
                            alignItems='flex-start'
                            w='100%'
                            mb='3rem'
                            
                            px='1rem'
                        >
                            <Box
                                w='100%'
                                d='flex'
                                flexDir='column'
                            >
                                <Text
                                    fontSize='15px'
                                    color='#222222'
                                    fontWeight='800'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                    mb='1rem'
                                >
                                </Text>
                                
                                    <Box
                                        w='100%'
                                        d='flex'
                                        justifyContent='space-between'
                                        alignItems='center'
                                        mb='3rem'
                                        px='1rem'
                                    >
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Class</Text>  
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Degree</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Specialization</Text>    
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Date</Text>                
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Time</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Session</Text>
                            <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='14%' textAlign='center'>Question</Text>
                                    </Box>
                                    <Box
                                        w='100%'
                                        d='flex'
                                        justifyContent='space-between'
                                        alignItems='center'
                                        mb='3rem'
                                        px='1rem'
                                    >
                                    <ExamScheduleList schedules={scheduleList} />
                                     
                                     </Box>
                                                  
                            </Box>


                        </Box>
                        </TabPanel>
                       
                    </TabPanels>
                </Tabs>
            </Box>
        </Box>
    </Box>
    )
}